
import {useState,React} from 'react';
import { Link } from 'react-router-dom';
import './BottomBar.css'; // Import the CSS file for styling
import Projects from './Projects';
const BottomBar = () => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();  // Prevent default link behavior to toggle border on click
    setIsClicked(!isClicked);
  }
  return (
    <div className="bottm-bar1">
      <div className="frame-group">
        <div className="profile-wrapper">
          <div className="home-container">
          <Link to="/">
            <img className="bimoon-fill-icon" alt="Home" src="profile.svg" />
            </Link>
          </div>
        </div>

        <img className="frame-child11" alt="Frame" src="frame-5.svg" />
        <div className="home-container">
        <Link to="/Education">
            <img className="bimoon-fill-icon" alt="Education" src="./Education (2).svg" />
        </Link>
      </div>

        <div className="frame-child12"></div>

        <div className="home-container">
        <Link to="/Projects">
          <img className="bimoon-fill-icon" alt="Projects" src="iconlybulklightbulb.svg" />
          </Link>
        </div>
        <div className="home-container">
        <Link to="/WorkExperience">
          <img className="bimoon-fill-icon" alt="WorkExperience" src="./WorkExperience.svg" />
          </Link>
        </div>
        <div className="home-container">
        <Link to="/CardSlider">
          <img className="bimoon-fill-icon" alt="Certificates" src="./cert.svg" />
          </Link>
        </div>
        <div className="home-container">
        <Link to="/Patents">
          <img className="bimoon-fill-icon" alt="Patents" src="./Pate.svg" />
          </Link>
        </div>
        <div className="home-container">
        <Link to="/Skills">
          <img className="bimoon-fill-icon" alt="Projects" src="skills.svg" />
          </Link>
        </div>
        <div className="frame-child12"></div>
        <div className="home-container">
        <Link to="/Achievements">
          <img className="bimoon-fill-icon" alt="Awards" src="./Achievements.svg" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
